<div class="modal-form">
  <div class="card form-modal">
    <div class="card-header" style="text-align: left;">
      <h4> {{item.titulo}}</h4>
      <div class="close-button" (click)="close()">
        x
      </div>
    </div>
    <div class="card-body" style="text-align: left">
      <div class="form-group row">
        <label class="col-3 col-form-label" for="nombre">Nombre</label>
        <div class="col-9">
          <input type="text" class="form-control" id="nombre" [(ngModel)]="nombre" placeholder="Ingrese el nombre">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label" for="modelo">Modelo</label>
        <div class="col-9">
          <input type="text" class="form-control" id="modelo" [(ngModel)]="modelo" placeholder="Ingrese el modelo">
        </div>
      </div>
      <div class="form-group row">
        <label for="grupo" class="col-3 col-form-label">Grupo</label>
        <div class="col-9" style="text-align: center">
          <div ngbDropdown>
            <button class="btn" id="equipo-grupo" ngbDropdownToggle id="grupo"
                    style="width: 100%">
              {{selected_grupo ? selected_grupo.nombre : 'Selecione un grupo'}}
            </button>
            <div ngbDropdownMenu aria-labelledby="equipo-grupo" style="width: 100%">
              <button class="dropdown-item" *ngFor="let grupo of grupos" (click)="selectGrupo(grupo)"
              >{{grupo.nombre}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label">Provincia</label>
        <div class="col-9">
          <select class="form-control" [(ngModel)]="selectedProvincia"
                  (ngModelChange)="onProvinciaChange()">
            <option [ngValue]="null" disabled>Seleccione una provincia</option>
            <option *ngFor="let prov of provincias" [ngValue]="prov">{{prov.nombre}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label">Ciudad</label>
        <div class="col-9">
          <select class="form-control" [(ngModel)]="selectedCiudad"
                  (ngModelChange)="onCiudadChange()" [disabled]="!selectedProvincia">
            <option [ngValue]="null" disabled>Seleccione una ciudad</option>
            <option *ngFor="let ciudad of ciudadesFiltradas" [ngValue]="ciudad">{{ciudad.nombre}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label" for="fecha-sd">Fecha SD</label>
        <div class="col-9">
          <input class="form-control" type="date" [value]="sdFecha | date:'yyyy-MM-dd'"
                 (input)="sdFecha = $event.target.valueAsDate" id="fecha-sd">
        </div>
      </div>
      <br>
      <div style="text-align: center">
        <button class="btn" (click)="close()" style="margin-right: 10px">Cancelar</button>
        <button [disabled]="!(nombre && modelo && selected_grupo)"
                class="btn" (click)="success()">Guardar
        </button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/modal-equipo/modal-equipo.component.html